var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpandDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7627 10.4583C15.5207 10.1893 15.1064 10.1675 14.8375 10.4096L11.9999 12.9634L9.16231 10.4096C8.89336 10.1675 8.4791 10.1893 8.23704 10.4583C7.99498 10.7272 8.01678 11.1415 8.28574 11.3836L11.5616 14.3318C11.8108 14.5561 12.189 14.5561 12.4382 14.3318L15.714 11.3836C15.983 11.1415 16.0048 10.7272 15.7627 10.4583Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandDown);
export default __webpack_public_path__ + "static/media/expandDown.247aebd00cf4f9da16062867826c6182.svg";
export { ForwardRef as ReactComponent };